import React from 'react';
import { getClassName } from '@onsolve-ucl/utils.get-class-name';
import styles from './PopoverHeader.module.scss';
import { IconButton } from '@components/IconButton';
import TimesIcon from '@components/Times';
import keyCodes from '../../utils/keyCodes';
const PopoverHeader = ({ className, children, iconLabel, onClose = () => null, testIdPrefix, }) => {
    const [rootClass, getChildClass] = getClassName({
        rootClass: 'popoverHeader',
        className,
        styles,
    });
    const handleKeyDown = (e) => {
        if (e.keyCode === keyCodes.ENTER_KEY) {
            e.preventDefault();
            onClose(e);
        }
    };
    const handleClose = (e) => onClose(e);
    return (<div className={rootClass}>
            <div className={getChildClass('title')} data-testid={testIdPrefix ? `${testIdPrefix}__title` : undefined}>
                {children}
            </div>
            <IconButton className={getChildClass('action')} onClick={handleClose} onKeyDown={handleKeyDown} tabIndex={0} aria-label={iconLabel} data-testid={testIdPrefix ? `${testIdPrefix}__close` : undefined}>
                <TimesIcon color="secondary"/>
            </IconButton>
        </div>);
};
PopoverHeader.displayName = 'PopoverHeader';
export default PopoverHeader;
